<script>
  import { onMount, createEventDispatcher } from 'svelte';
  import {validateForm} from '../Form/utils.js';
  import ComboSelect from '../ComboSelect/ComboSelect.svelte';
  import HazardControlItem from './HazardControlItem.svelte';
  import yup, {object, number} from 'yup';
  import Button from '../Button.svelte';
  import {submit} from '../Form/utils.js';
  import Errors from '../Errors.svelte';
  import {sgettext} from '../../i18n.js';



  export let editMode = true;
  export let hazardOptions = [];
  export let item = null;
  export let currentRow = null;
  export let promptConfirmationId = '';
  export let actionUrl = '';
  export let editable = true;
  export let evId = null;
  export let data = [];
  export let showForm = false;

  const dispatch = createEventDispatcher();

  let selectedHazard = null;
  let selectedControl = null;
  let sending = false;
  let controlOptions = [];
  let formErrors = null;

  let schema = object().shape({
    global_hazard_id: number()
      .required(sgettext('$$REQUIRED_FIELD$$'))
      .typeError(sgettext('$$REQUIRED_FIELD$$')),
    global_control_id: number()
      .required(sgettext('$$REQUIRED_FIELD$$'))
      .typeError(sgettext('$$REQUIRED_FIELD$$'))
  });

  let payload = {
    global_hazard_id: null,
    global_control_id: null,
    element_version: evId
  }

  let promptConfirmation = false;

  let fieldIsValid = getDefaultFieldIsValid();


  function getDefaultFieldIsValid() {
    return {
      global_hazard_id: {
        isValid: true,
        errors: ''
      },
      global_control_id: {
        isValid: true,
        errors: ''
      }
    }
  }

  async function handleHazardChanged(event){
    payload.global_control_id = null;
    if(event.detail.value){
      controlOptions = selectedHazard.global_controls;
      formErrors = null;
    }
  }

  async function handleSave() {
    try {
      sending = true;
      let method = 'POST';
      let url = actionUrl;
      await validateForm(schema, payload);

      if(item) {
        method = 'PATCH';
        url = `${actionUrl}${item.id}/`
      }
      const response = await submit(url, method, payload);
      if(item){
        item.global_hazard = selectedHazard;
        item.global_control = selectedControl;
      } else {
        data = [...data, response];
        dispatch('completed', {});
      }
      editMode = false;
      formErrors = null;
    } catch(err) {
      if (err.inner) {
        err.inner.forEach((er) => {
            fieldIsValid[er.path].isValid = false;
            fieldIsValid[er.path].errors = er.message;
        });
        data = [...data];
      }else{
        formErrors = err;
      }
    } finally {
      sending = false;
    }
  }

  function handleCancel() {
    editMode = false;
    showForm = false;
    formErrors = null;
  }

  function handleEdit() {
    editMode = true;
    payload = {
      global_hazard_id: item.global_hazard.id,
      global_control_id: item.global_control.id,
      element_version: item.element_version
    }
    selectedHazard = item.global_hazard;
    selectedControl = item.global_control;
    const hazard = hazardOptions.filter(h => h.id === item.global_hazard.id);
    if(hazard.length) {
      controlOptions = hazard[0].global_controls;
    }
  }

  async function handleDelete () {
    promptConfirmation = true;
    currentRow = item;

    jQuery(`#${promptConfirmationId}`).modal('show');
  }
</script>



<style>

  .actions {text-align: right;}

</style>

{#if item || editMode}
<tr>
  {#if editMode}
    <td>
      <ComboSelect
        id="global_hazard_id"
        bind:options={hazardOptions}
        bind:selected={selectedHazard}
        bind:value={payload.global_hazard_id}
        bind:isValid={fieldIsValid.global_hazard_id.isValid}
        bind:errors={fieldIsValid.global_hazard_id.errors}
        on:changed={handleHazardChanged}
        searchable={true}
        {schema} />
    </td>
    <td>
      <ComboSelect
        id="global_control_id"
        bind:options={controlOptions}
        bind:selected={selectedControl}
        bind:value={payload.global_control_id}
        bind:isValid={fieldIsValid.global_control_id.isValid}
        bind:errors={fieldIsValid.global_control_id.errors}
        searchable={true}
        {schema} />
    </td>
    {#if editable}
    <td>
      <div class="actions d-flex flex-nowrap justify-content-end">
        <Button
          type="primary btn-sm mr-1"
          on:click={handleSave}
          name={sgettext("$$SAVE$$")}
          disabled={sending}
        ></Button>
        <Button
          type="secondary btn-sm"
          on:click={handleCancel}
          name={sgettext("$$CANCEL$$")}
          disabled={sending}
        ></Button>
      </div>

    </td>
    {/if}
  {:else}
    <td>
      {#if item.global_hazard}
      <HazardControlItem data={item.global_hazard} />
      {/if}
    </td>
    <td>
      {#if item.global_control}
      <HazardControlItem data={item.global_control} />
      {/if}
    </td>
    {#if editable}
    <td>
      <div class="actions d-flex flex-nowrap justify-content-end">
        <Button
          type="outline btn-sm mr-1"
          on:click={handleEdit}
          name={sgettext("$$EDIT$$")}
          disabled={sending}
        ></Button>
        <Button
          type="outline btn-sm"
          on:click={handleDelete}
          name={sgettext("$$DELETE_1$$")}
          disabled={sending}
        ></Button>
      </div>
    </td>
    {/if}
  {/if}

</tr>
{/if}
{#if formErrors}
  <tr>
    <td colspan="3">
      <Errors errors={formErrors} />
    </td>
  </tr>
{/if}
